import { render } from "./TwoFactorStart.vue?vue&type=template&id=16825c6c&scoped=true"
import script from "./TwoFactorStart.vue?vue&type=script&lang=ts"
export * from "./TwoFactorStart.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-16825c6c"

export default script